import React from "react";
import { Card, Button, Typography, Space, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { theme } from "../../../../utils/theme";

const { Title, Text } = Typography;

const ExperienceCard = ({ experience, onEdit, onDelete }) => {
  const formatDate = () => {
    const startDate = `${experience.startMonth}/${experience.startYear}`;

    if (!experience.endMonth || !experience.endYear) {
      return `${startDate} - Devam Ediyor`;
    }

    return `${startDate} - ${experience.endMonth}/${experience.endYear}`;
  };

  return (
    <Card
      style={{ width: "100%", marginBottom: 16 }}
      bodyStyle={{ padding: 16 }}>
      <Space direction="vertical" size={0} style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}>
          <Space direction="vertical" size={0}>
            <Title level={4} style={{ color: theme.primaryColor, margin: 0 }}>
              {experience.jobPosition.name}
            </Title>
            <Text>{formatDate()}</Text>
            <Text type="secondary">{`${experience.companyName} - ${experience.companySector.name}`}</Text>
          </Space>
          <Space>
            <Button type="primary" icon={<EditOutlined />} onClick={onEdit}>
              Düzenle
            </Button>
            <Popconfirm
              title="Deneyimi Sil"
              description="Bu deneyimi silmek istediğinize emin misiniz?"
              onConfirm={onDelete}
              okText="Evet"
              cancelText="Hayır">
              <Button danger icon={<DeleteOutlined />}>
                Sil
              </Button>
            </Popconfirm>
          </Space>
        </div>
        <Text>{experience.description || "Tanım bulunmamaktadır."}</Text>
      </Space>
    </Card>
  );
};

export default ExperienceCard;
